import styled from 'styled-components';

const widthVariations: any = {
  registered: '700px',
  privatePolicy: '414px',
};

export const modalStyles = (step: string) => ({
  content: {
    width: `${widthVariations[step] ? widthVariations[step] : '414px'}`,
    minHeight: '370px',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    borderRadius: '16px',
    transform: 'translate(-50%, -50%)',
  },
  overlay: {
    background: 'rgb(31 31 30 / 73%)',
    zIndex: '998',
  },
});

export const CloseIcon = styled.a`
  position: absolute;
  right: 20px;

  :hover {
    svg {
      width: 20px;
      height: 20px;
      transition: 0.3s;
    }
  }
`;
